import {createContext} from 'react';

/**
 * True below a `NonCriticalBoundary`: the work of these parts does not hold the SSR shell
 * (`coreHooks/useShellGate`), they are streamed after it.
 */
const NonCriticalContext = createContext(false);

export default NonCriticalContext;
